var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{attrs:{"type":"file"},on:{"change":_vm.handleFileChange}}),_c('canvas',{ref:"canvas"})])
}
var staticRenderFns = []

export { render, staticRenderFns }